module.exports = __webpack_public_path__ + "static/media/donation.015b3402.svg";